<template>
  <b-card no-body>
      <b-card-header>
        <b-form inline>
          <location-select
            id="location-select"
            ref="location_select"
            class="ml-2 mr-2 flex-fill"
            :is-disabled="isDisabled"
            v-on:onSelect="onSelect"
          />
          <b-button
            variant="success"
            size="sm"
            :disabled="isDisabled || !selectedId"
            @click="onAdd(selectedId)"
          >
            <font-awesome-icon icon="plus" class="mr-1"/>
            Добавить
          </b-button>
        </b-form>
      </b-card-header>
      <b-table
        id="location-workers"
        ref="location-workers"
        class="mb-0"
        striped
        small
        thead-class="top-fixed-thead thead-light"
        table-class="text-small"
        responsive
        show-empty
        :busy.sync="isBusy"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :empty-text="$t('message.common.emptyTable')"
      >
        <template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"/>
            <strong>Загрузка</strong>
          </div>
        </template>
        <template #cell(name)="row">
          {{ row.item.name }}
        </template>

        <template #cell(action)="row">
          <b-button
            variant="danger"
            size="sm"
            :disabled="isDisabled"
            @click="onRemove(row.item)"
          >
            <font-awesome-icon icon="trash"/>
          </b-button>
        </template>
      </b-table>
  </b-card>
</template>

<script>
import workers from "../../network/workers";
import WorkerSelect from "../Workers/WorkerSelect";
import helpers from "../../utilites/helpers";
import LocationSelect from "../Locations/LocationSelect";

export default {
  name: "WorkerLocations",
  mixins: [
    workers, helpers
  ],
  components: { WorkerSelect, LocationSelect },
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      workerId: 0,
      items: [],
      fields: [
        {
          key: 'location.name',
          label: 'Название',
        },
        {
          key: 'action',
          label: 'Действия',
          class: 'widthAction'
        },
      ],
      currentPage: 1,
      perPage: 40,
      isBusy: false,
      selectedId: null
    }
  },
  methods: {
    configure(id) {
      this.workerId = id;
      this.getItems();

      this.configureLocationSelect();
    },
    configureLocationSelect() {
      if (this.$refs.location_select != null) {
        this.$refs.location_select.configure(0, this.workerId);
      }
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getWorkerLocations(this.workerId);
      this.isBusy = false;

      if (result.data == null) { return; }
      this.items = result.data;
    },
    onSelect(id) {
      this.selectedId = id;
    },
    async onRemove(item) {
      if (item.id == null) { return; }

      const title = "Удаление объекта исполнителя";
      const message = `Вы уверены, что хотите удалить объект: ${item.location.name}?`;
      this.showModalDelete(title, message, async function () {
        await this.onDelete(item.id);
      }.bind(this));
    },
    async onDelete(id) {
      this.isBusy = true;
      const result = await this.deleteLocationWorker(id);
      this.isBusy = false;

      if (result.data == null) { return;}

      this.configureLocationSelect();
      await this.getItems();
    },
    async onAdd(id) {
      if (id == null) { return; }

      const data = {
        location_id: id,
        worker_id: this.workerId
      }
      this.isBusy = true;
      const result = await this.postLocationWorker(data);
      this.isBusy = false;

      if (result.data == null) { return; }

      this.$refs.location_select.onClear();

      await this.getItems();
    },
  }
}
</script>

<style>
.widthAction {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkerLocations.vue